<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5713 10.2377L8.03576 6.70214L4.50022 10.2377" stroke="currentColor" stroke-linecap="round"/>
</svg>
